var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[(_vm.visible)?_c('v-flex',[_c('div',{staticClass:"xs-12 mx-5 my-3",domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }